// * Bootstrap libraries
import './_bootstrap';

// * Any other global site-wide JavaScript should be placed here.
// sicky_header
(function($, Drupal, drupalSettings, once) {
  'use strict';

  Drupal.behaviors.zaya_sticky_header = {
    attach: function(context, settings) {
      let stickyObserver = new IntersectionObserver(function(entries) {
        if(entries[0].intersectionRatio === 0)
          document.querySelector(".page__header_sticky").classList.add("sticked");
        else if(entries[0].intersectionRatio === 1)
          document.querySelector(".page__header_sticky").classList.remove("sticked");
      }, { threshold: [0,1] });
      stickyObserver.observe(document.querySelector("nav.navbar"));

      if (context === document) {
        $(context).on("drupalViewportOffsetChange.toolbar", function (event, offsets) {
          // Offset to be applied to any data-sticky-header-offset,
          // elements sticky beyond sticky header (like offcanvas).
          var beyondStickyHeaderElements = document.querySelectorAll('[data-beyond-sticky-header],.beyond-sticky-header');
          beyondStickyHeaderElements.forEach(function (selector) {
            let pageHeaderSticker = document.querySelector('.page__header_sticky.sticked')
            if ($(beyondStickyHeaderElements).length > 0 && pageHeaderSticker) {
              const stickyHeaderOffset = pageHeaderSticker.getBoundingClientRect().height;
              $(selector).css("top", offsets.top + stickyHeaderOffset);
            }
          });

        });
      }

    }
  };

})(jQuery, Drupal, drupalSettings, once);

